// extracted by mini-css-extract-plugin
export default {"image":"ImageNode_image__KXMFS","video":"ImageNode_video__sr0a6","document":"ImageNode_document__vjHa-","text":"ImageNode_text__dJOwJ"};